import { atom, selector } from 'recoil';
import { Breadcrumb, CallToAction, Link, Variant } from '~/common/models';
export interface CompareRangeModel {
  modelId?: string;
  modelName?: string;
  modelTitle?: string;
  modelBadgeUrl?: string;
  modelPimIdentifier?: string;
  modelImageSrc?: string;
  modelVariants?: CompareRangeVariant[];
  pimModelVariants?: PimModelVariant[];
  brochureUrl?: string;
  leadInHeading?: string;
  leadInHeadingDisclaimer?: string;
  leadInText?: string;
  hideCompareRangeButton?: boolean;
  marketingCategoryOrder?: string[];
  showVariantGrouping?: boolean;
  hideGfv?: boolean;
}

export interface PimModelVariant {
  modelPimIdentifier: string;
  variantPimIdentifier: string;
}

export interface CompareRangeVariant extends Variant {
  isHighlight?: boolean;
  selectedColourCode?: string;
  introText?: string;
  offersUrl?: Link;
  learnMore?: CallToAction;
  buildYourOwn?: CallToAction;
  viewSpecsAndFeat?: CallToAction;
  brochureDownload?: CallToAction;
  compareOtherSpotlight?: boolean;
  colourDisclaimer?: string;
  keyFeatureDisclaimer?: string;
  hidePriceDetails: boolean;
}
export interface CompareOtherModels {
  heading?: string;
  subHeading?: string;
  isVisible?: boolean;
  models?: CompareRangeModel[];
}

export const ActiveModelState = atom<CompareRangeModel | null>({
  key: 'ActiveModelState',
  default: null,
});

export const ModelWalkModelsState = atom<CompareRangeModel[]>({
  key: 'ModelWalkModels',
  default: [],
});

export const VehicleModelName = selector<string | undefined>({
  key: 'ModelWalkVehicleModelName',
  get: ({ get }) => get(ActiveModelState)?.modelName,
});

export const CompareRangeVariants = selector({
  key: 'ModelWalkCompareRangeVariants',
  get: ({ get }) => get(ActiveModelState)?.modelVariants ?? [],
});
